export default __webpack_public_path__ + "static/media/rotate-ccw.4888cf3b.svg";